/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  IndexRoute,
  Route,
} from 'react-router';
import Application from '../Application';
import ApplicationDetail from '../Application/coms/ApplicationDetail';
import DetailView from '../Application/coms/ApplicationDetail/coms/DetailView';
import LogView from '../Application/coms/ApplicationDetail/coms/LogView';
import APIView from '../Application/coms/ApplicationDetail/coms/APIView';
import ExportView from '../Application/coms/ApplicationDetail/coms/ExportView';
import BatchImport from '../Application/coms/ApplicationDetail/coms/BatchImport';
import ParseView from '../Application/coms/ApplicationDetail/coms/ParseView';
import ParserDetail from '../Application/coms/ApplicationDetail/coms/ParseView/coms/ParserDetail';
import DataPointsView from '../Application/coms/ApplicationDetail/coms/DataPointsView';
import DataPointTrend from '../Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPointTrend';
import AppDebug from '../Application/coms/ApplicationDetail/coms/APIView/coms/AppDebug';
import FlowsView from '../Application/coms/ApplicationDetail/coms/FlowsView';
import BroadcastView from '../Application/coms/ApplicationDetail/coms/BroadcastView';
import DashBoard from '../Application/coms/ApplicationDetail/coms/DashBoardView';
import NewDashboard from '../Application/coms/ApplicationDetail/coms/DashBoardView/coms/NewDashboard';
import SingleDetail from '../Application/coms/ApplicationDetail/coms/DashBoardView/coms/SingleDetail';
import MultipleDetail from '../Application/coms/ApplicationDetail/coms/DashBoardView/coms/MultipleDetail';
import ChartDetail from '../Application/coms/ApplicationDetail/coms/DashBoardView/coms/ChartDetail';
import AddFlow from '../Application/coms/ApplicationDetail/coms/FlowsView/coms/AddFlow';
import DeviceRoutes from './DeviceRoutes';

const AppRoutes = (
  <Route path="application">
    <IndexRoute component={Application} />
    <Route path=":id" component={ApplicationDetail}>
      <IndexRoute component={DetailView} />
      <Route path="detail" component={DetailView} />
      <Route path="log" component={LogView} />
      <Route path="api" component={APIView} />
      <Route path="export" component={ExportView} />
      <Route path="batchimp" component={BatchImport} />
      <Route path="parse" component={ParseView} />
      <Route path="parse/:parserId" component={ParserDetail} />
      <Route path="dps" component={DataPointsView} />
      <Route path="dps/:dpId/trend" component={DataPointTrend} />
      <Route path="flows" component={FlowsView} />
      <Route path="flows/add" component={AddFlow} />
      <Route path="broadcast" component={BroadcastView} />
      <Route path="dashboard" component={DashBoard} />
      <Route path="dashboard/add" component={NewDashboard} />
      <Route path="dashboard/basic/:dashid" component={SingleDetail} />
      <Route path="dashboard/map/:dashid" component={MultipleDetail} />
      <Route path="dashboard/:dashid/:dps" component={ChartDetail} />
    </Route>
    {DeviceRoutes}
    <Route path=":id/debug" component={AppDebug} />
  </Route>
);

export default AppRoutes;




// WEBPACK FOOTER //
// ./src/containers/Routes/AppRoutes.jsx